import { render, staticRenderFns } from "./BirthdaySelect.vue?vue&type=template&id=4d692bac&"
import script from "./BirthdaySelect.vue?vue&type=script&lang=js&"
export * from "./BirthdaySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports